import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  investmentStrategyDocumentsAllIds,
  investmentStrategyDocumentsById,
  investmentStrategyDocumentsSelector,
  investmentStrategyDocumentsMetadataSelector,
] = resourceSelectors('investmentStrategyDocuments');
